
import { Component, Vue, Prop } from "vue-property-decorator";

import { IStudentProgramsData } from "@/models/subscriptions/program";

import {
  ESubscriptionStatus,
  ESubscriptionProgressStatus
} from "@/models/subscriptions/status";

@Component({
  name: "CUserCatalogSubscription"
})
export default class CUserCatalogSubscription extends Vue {
  @Prop({ required: true }) public subscription!: IStudentProgramsData;

  public ESubscriptionStatus = ESubscriptionStatus;
  public ESubscriptionProgressStatus = ESubscriptionProgressStatus;

  public progressColor() {
    switch (this.subscription.program_status) {
      case ESubscriptionStatus.AWAITING_COMPLETION:
      case ESubscriptionStatus.AWAITING_CONFIRMATION:
        return "#FFAB00";
      case ESubscriptionStatus.FAILED:
        return "#FA4747";
      default:
        return "#1E64AA";
    }
  }
}
